import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.5 9.07143H9.07143V15.5H6.92857V9.07143H0.5V6.92857H6.92857V0.5H9.07143V6.92857H15.5V9.07143Z",
		fill: "currentColor"
	})
});
export default SvgPlus;
